/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Hero_CtaInputs */

const ja_playdata_home_hero_cta = /** @type {(inputs: Playdata_Home_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const en_playdata_home_hero_cta = /** @type {(inputs: Playdata_Home_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Sample`)
};

/**
* | output |
* | --- |
* | "Download Sample" |
*
* @param {Playdata_Home_Hero_CtaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_hero_cta = /** @type {((inputs?: Playdata_Home_Hero_CtaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Hero_CtaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_hero_cta(inputs)
	return en_playdata_home_hero_cta(inputs)
});